module.exports = __webpack_public_path__ + "img/1.407d1bd6.jpg";